import { z } from 'zod'

import { afterValid } from '~/services/api/contracts/afterValid'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdatePasswordRequestSchema } from '~/services/api/generated'
import { refinePasswordConfirmation } from '~/services/api/contracts/refinePasswordConfirmation'

const PasswordSettingsUpdateSchema = UpdatePasswordRequestSchema.extend({
  password_confirmation: z.string().min(1)
})

export const PasswordSettingsUpdate = (_context: NoContext = {}) =>
  afterValid(PasswordSettingsUpdateSchema, refinePasswordConfirmation)
